import { useQuery } from '@tanstack/react-query';
import { getUsersGroup } from 'services/api/requests/authentication';

export const useGetUsersGroup = () => {
	return useQuery(['users-group-list'], getUsersGroup, {
		refetchOnWindowFocus: false,
	});
};
